<template>
    <div style="padding: 10px 20px;">
        <el-row>
            <el-col :span="24" style="text-align: left; padding-top: 30px;">
                <span class="mainTitle">
                    Zhoushan Chenxi New Material Co., Ltd.
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12"  style="text-align: left;padding:20px 60px;">
                <span  class="mainContent">

                    Zhoushan Chenxi New Material Co., Ltd.（short for
Chenxi New Material）was established in 2021 at
Zhoushan, Zhejiang. We are a professional chemical
products and chemical derivatives trade distribution
company. Our main products are PPG&POP、PU
Additives、Isocyanate and PCE. We have a professional
marketing team, rich product channels and stable
customer groups. We also provide the whole chain of
marketing services and solutions, with a high market
share in automotive, household appliances,
electronics/ communications, medical, food, daily
chemicals and other fields.
<br>
<br>

                </span>
                
            </el-col>
            <el-col :span="12"  style="text-align: left;padding:20px 60px;">
                <img src="../../../../assets/images/companyInfo.png" class="mainPic"/>
                
            </el-col>
        </el-row>
        <br>
        <br>
        <el-row>
            <el-col :span="24" class="mainProduct">
                Products and Applications
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-carousel :interval="4000" type="card" height="400px">
                    <el-carousel-item v-for="item in 6" :key="item">
                    <h3 class="medium">
                        <el-image :src="require('../../../../assets/images/product/product_00' + + item + '.png')" class="mainPic" lazy/>
                    </h3>
                    </el-carousel-item>
                </el-carousel>
            </el-col>
        </el-row>
        <br>
        <br>
        <el-row>
            <el-col :span="24" class="mainProduct">
                Industry News
            </el-col>
        </el-row>
        <el-row>
            <el-col v-for="( item ) in mainProductDetail" :key="item.key" :span="10" :offset="1" style="padding: 0 30px  60px 30px;">
            <el-card :body-style="{ padding: '0px' }" style="">
                <el-image :src="item.img" alt="img" class="image" fit="contain" style="height: 100%; width: 100%;"/>
                <div style="padding: 14px">
                    <el-row>
                        <el-col :span="18" class="mainProductDetail_title">
                            {{ item.title }}
                        </el-col>
                        <el-col :span="6" class="mainProductDetail_entryDate">
                            {{ item.currentDate }}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" class="mainProductDetail_description">
                            {{ item.description }}
                        </el-col>
                    </el-row>
                </div>
            </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import api from '@/api/api'
// import cxf from '@/utils/GeneralFn'

export default {
    name: "en_Home",
    components: {  },
    data() {
        return {
            mainProductDetail: [],
            productList:{}
        }
    },
    created(){
        this.initProductList();
    },
    mounted(){
        
    },
    methods:{
        async initProductList () {
            await this.getProductList();
            await this.handleProductShow();
        },
        async getProductList(){
            let data = {
                pageNo: 1,
                pageSize: 10,
                searchParameters: [
                    {
                        "field": "lang",
                        "op": 1,
                        "value": "zh"
                    }, 
                ]
            };
            let _res = await api.postNewsListD( data );
            this.productList = _res.data.data;
        },
        async handleProductShow () {
            const _resData = this.productList;
            _resData.rows.forEach( async (e, index ) => {
                if ( index < 6 ) {
                    this.mainProductDetail.push({
                        title:  e.title,
                        description: e.content,
                        img: await this.getImage( e.attchs[0] ),
                        key: uuidv4(),
                        currentDate: e.createdTime
                    })
                }
            });
        },
        async getImage( id ) {
            if (id) {
                let _tempRes = await api.getSysFileInfoPreview({id: id});
                if ( _tempRes.status === 200 ) {
                    return window.URL.createObjectURL(new Blob([_tempRes.data]));
                } else {
                    return '--';
                }
            } else {
                return "No Images"
            }
        },
    }
}
</script>

<style>
.image {
    width: 300px;
    height: 200px;
}
.mainProduct {
    margin-bottom: 20px;
    font-size: 36px;
}
.mainProductDetail_title {
    text-align: left;
    font-size: 28px;
    padding-left: 20px;
    padding-bottom: 20px;
}
.mainProductDetail_entryDate {
    text-align: right;
    font-size: 14px;
    color: darkgray;
}

.mainProductDetail_description {
    text-align: left;
    font-size: 14px;
    color: #333;
    line-height: 2em;
    padding: 0 10px;
}
</style>